<template>
  <div class="container py-5">
    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div v-else-if="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>

    <div v-else>
      <div>
        <!-- <router-link button :to="`/need-help/${$route.query.orderNumber}`">
          <b-icon icon="arrow-left-short" scale="2" variant="black"></b-icon>
        </router-link> -->
        <b-button @click="$router.go(-1)" variant="link">
          <b-icon icon="arrow-left-short"></b-icon>
        </b-button>
      </div>
      <h1 class="mb-4 text-center">{{ terms.title }}</h1>
      <div
        v-for="section in terms.sections"
        :key="section._id"
        class="mb-4 pb-3"
      >
        <h5 class="">{{ section.subtitle }}</h5>
        <div class="tick" v-html="section.description"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsAndConditions",
  data() {
    return {
      loading: true,
      error: null,
      terms: {},
    };
  },
  methods: {
    async fetchTerms(id) {
      this.loading = true;
      this.error = null;

      try {
        const payload = { id };
        const result = await this.$store.dispatch(
          "termsConditions/termConditionResponseAction",
          payload
        );

        if (result && result.data && result.data.data) {
          this.terms = result.data.data;
        } else {
          this.error = "Failed to load terms and conditions.";
        }
      } catch (err) {
        this.error = "An error occurred while fetching data.";
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    const tenantId = process.env.VUE_APP_TENANT;

    const privacyResult = await this.$store.dispatch(
      "termsConditions/privacySettingListAction",
      tenantId
    );

    let slug = null;
    let id = null;
    if (privacyResult && Array.isArray(privacyResult.data.data)) {
      const found = privacyResult.data.data.find(
        (item) => item.content === "termsCondition" && item.scope === "customer"
      );
      if (found) {
        slug = found.slug;
        id = found._id;
      }
    }

    if (slug && id) {
      await this.fetchTerms(id);
    } else {
      this.error = "Terms and conditions not found for customer.";
      this.loading = false;
    }
  },
};
</script>

<style scoped></style>
<style>
.bi-arrow-left-short {
  height: 3rem;
  width: 3rem;
  color: var(--primarycolor);
  padding: 0px;
}

.bi-arrow-left-short:hover {
  color: var(--darkcolor);
}
.tick ul {
  list-style: none;
  padding-left: 0;
}

.tick ul li {
  position: relative;
  padding-left: 1.5em;
  margin-bottom: 0.5em;
}

.tick ul li::before {
  content: "✓";
  color: #28a745;
  position: absolute;
  left: 0;
  font-weight: bold;
}
</style>
